import { render, staticRenderFns } from "./dcops_fault_board.vue?vue&type=template&id=574748c6&scoped=true"
import script from "./dcops_fault_board.vue?vue&type=script&lang=js"
export * from "./dcops_fault_board.vue?vue&type=script&lang=js"
import style0 from "./dcops_fault_board.vue?vue&type=style&index=0&id=574748c6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574748c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('574748c6')) {
      api.createRecord('574748c6', component.options)
    } else {
      api.reload('574748c6', component.options)
    }
    module.hot.accept("./dcops_fault_board.vue?vue&type=template&id=574748c6&scoped=true", function () {
      api.rerender('574748c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/boardManage/dataOperation/dcops_fault_board.vue"
export default component.exports